module.exports = __webpack_public_path__ + "static/media/distributive-book.6a5ac1da.png";